/* eslint-disable @typescript-eslint/ban-ts-comment */
import { IMessage } from '@base/features/message/message';
import MainButton from '@ui-kit/components/mainButton';
import { useScript } from '@utils/hooks';
import React, { useEffect, useState } from 'react';
import { container } from 'tsyringe';
import { AmazonPurchaseOptions } from '../model/interfaces';
import TicketsService from '../model/ticketsService';

export default function AmazonPayButton(props: { options: AmazonPurchaseOptions; onSuccess?: () => void }) {
  const message: IMessage = container.resolve('message');
  const ticketsService: TicketsService = container.resolve('ticketsService');
  const [purchaseData, setPurcaseData] = useState({
    accessToken: '',
    orderReferenceId: '',
    price: props.options.amount,
  });
  const [loading, setLoading] = useState(false);
  useScript('https://static-na.payments-amazon.com/OffAmazonPayments/us/sandbox/js/Widgets.js');

  function showButton() {
    let authRequest;
    let accessToken: string;
    //@ts-ignore
    OffAmazonPayments.Button('AmazonPayButton', props.options.sellerId, {
      type: 'PwA',
      color: 'Gold',
      size: 'medium',

      authorization: function () {
        const loginOptions = {
          scope: 'profile payments:widget',
          popup: true,
        };
        //@ts-ignore
        authRequest = amazon.Login.authorize(loginOptions, function (response: any) {
          accessToken = response.access_token;
          setPurcaseData((pd) => ({ ...pd, accessToken }));
        });
      },

      onSignIn: function (orderReference: any) {
        //@ts-ignore
        new OffAmazonPayments.Widgets.Wallet({
          sellerId: props.options.sellerId,
          onOrderReferenceCreate: function (orderReference: any) {
            const orderReferenceId = orderReference.getAmazonOrderReferenceId();
            setPurcaseData((pd) => ({ ...pd, orderReferenceId }));
          },
          design: {
            designMode: 'responsive',
          },
          onPaymentSelect: (orderReference: any) => {
            //
          },
          onError: function (error: any) {
            message.error(error.getErrorCode() + ': ' + error.getErrorMessage());
          },
        }).bind('walletWidgetDiv');
      },

      onError: function (error: any) {
        message.error(
          'The following error occurred: ' + error.getErrorCode() + ' - ' + error.getErrorMessage()
        );
      },
    });
  }

  function pay(data: { price: string; accessToken: string; orderReferenceId: string }) {
    setLoading(true);
    ticketsService
      .amazonBuy(data)
      .then((r) => {
        message.success(`${props.options.amount} tickets successfully purchased`);
        props.onSuccess?.();
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.message);
      });
  }

  useEffect(() => {
    (window as any).onAmazonLoginReady = function () {
      //@ts-ignore
      amazon.Login.setClientId(props.options.lwaClientId);
    };
    (window as any).onAmazonPaymentsReady = function () {
      showButton();
    };
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <div id="AmazonPayButton" style={{ textAlign: 'center' }} />
      {purchaseData.accessToken && (
        <div
          id="walletWidgetDiv"
          style={{
            width: '400px',
            height: '228px',
            margin: '1rem 0',
          }}
        />
      )}
      {purchaseData.orderReferenceId && (
        <MainButton onClick={() => pay(purchaseData)} loading={loading}>
          Buy
        </MainButton>
      )}
    </div>
  );
}
